import { ViewObjectContainerParser } from "../view-object-container-parser";
import { SettingsParser } from "../settings-parser";
import { PanelSettings } from "../../settings/view-objects/panel-settings";

export class PanelSettingsParser extends ViewObjectContainerParser {
  constructor(viewObjectParsers) {
    super(viewObjectParsers);
    this.parsedFieldNames.push("items");
  }

  static createSettings(settings, defaultSettings, viewObjectParsers) {
    let parsedSettings = ViewObjectContainerParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    let defaultViewObjects = settings._defaultViewObjects;
    if (settings.items !== undefined) {
      parsedSettings.items = [];
      for (let itemIndex = 0; itemIndex < settings.items.length; itemIndex++) {
        let parsedItem = ViewObjectContainerParser.parseItem(settings.items[itemIndex], viewObjectParsers, defaultViewObjects);
        parsedSettings.items.push(parsedItem);
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = PanelSettingsParser.createSettings(settings, defaultSettings, this.viewObjectParsers);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new PanelSettings(parsedSettings);
  }
}
